import React, { Fragment } from "react";
import { Button, TextLink } from "@vds/buttons";
import { Title, Body } from "@vds/typography";
import { Row, Col, Grid } from "@vds/grids";

export function InternetLTEService(props) {
  return (
    <>
      { (props?.isExternalAppRedirect ? props?.lqQualificationDetails?.Qualified_4g == "Y" : props?.addressQualificationDetails?.Qualified_4g == "true") ? (
        <Grid
          className="OutofFranchise"
          style={{ marginLeft: "3px" }}
          colSizes={{ mobile: 4, tablet: 12, desktop: 12 }}
          colGutter={false}
        >
          <Row className={`Page-Content ${props.bgForFirst} ${props.isMobileOnly?'mobile':''} ${(props.isTablet) ? 'tablet' : ''}`}>
            <Col
              className="Title-section"
              colSizes={{ mobile: 4, tablet: 9, desktop: 9 }}
            >
              <div className="Main-Title">
                <Title size="large" primitive="h2">
                  LTE Business Internet
                </Title>
              </div>
              <div></div>
            </Col>

            <Col
              colSizes={{ mobile: 4, tablet: 5, desktop: 5 }}
              colGutter={true}
            >
              <Body size="large" primitive="h2">
                Reliable, flexible, plug-and-play wireless connectivity ready to
                go virtually anywhere you do business on Verizon’s 4G LTE
                network.
              </Body>
            </Col>
            <div className={`gap ${props.isMobileOnly ? 'mobile':''}`}></div>
            <Col
              colSizes={{ mobile: 2, tablet: 3, desktop: 3 }}
              colGutter={true}
            >
              <Body size="large" primitive="h2" bold={true}>
                Prices start at:
              </Body>
              <Body size="large" primitive="h2">
                $69/mo*
              </Body>
            </Col>
            <Col
              colSizes={{ mobile: 2, tablet: 2, desktop: 2 }}
              colGutter={true}
            >
              <Body size="large" primitive="h2" bold={true}>
                Speeds start at:
              </Body>
              <Body size="large" primitive="h2">
                10 Mbps (download)
              </Body>
            </Col>

            <Col
              colSizes={{ mobile: 6, tablet: 5, desktop: 5 }}
              colGutter={true}
            ></Col>
            <div className={`gap ${props.isMobileOnly ? 'mobile':''}`}></div>
            <Col
              colSizes={{ mobile: 4, tablet: 6, desktop: 6 }}
              colGutter={true}
            >
              <Body size="large" primitive="h2" bold={true}>
                Benefits:
              </Body>
              <Body size="large" primitive="h2">
                Flexible, fast, mobile.
              </Body>
            </Col>

            <Col
              colSizes={{ mobile: 4, tablet: 5, desktop: 5 }}
              colGutter={true}
            ></Col>
            <div className={`gap ${props.isMobileOnly ? 'mobile':''}`}></div>
            <Col
              colSizes={{ mobile: 4, tablet: 6, desktop: 6 }}
              colGutter={true}
              className="topSpace"
            >
              <Body size="large" primitive="h2" bold={true}>
                LTE Business Internet is best for:
              </Body>
              <Body size="large" primitive="h2">
                Businesses that need reliable connections when and where workers
                need them most, from pop-up stores to construction sites to
                small offices and retail locations.
              </Body>
            </Col>

           { props.isMobileOnly ? ( <Col
              className="Title-section"
              colSizes={{ mobile: 4, tablet: 6, desktop: 6 }}
              className="topSpace"
            >
              <Body size="small" primitive="h2">
                {" "}
                *First-year price. Plus taxes, fees & equip. charges. Speeds
                vary. Data allowance and other terms apply. Click BUY for
                details.
              </Body>
            </Col> ): (<Col
              className="Title-section" 
            >
            </Col>)}
            <Col
              className="Title-section"
              colSizes={{ mobile: 4, tablet: 5, desktop: 5 }}
            >
              <div className="Main-Title">
                <Button
                  secondary
                  size="large"
                  onClick={() => {props.redirectionHandler();props.enableSpinner()}}
                  className={`${props.bgForFirst ? "bgBtn" : "transperentButton"} ${props.isMobileOnly?'button-mobile':''}`}
                >
                  Buy
                </Button>
              </div>
            </Col>
            <div className={`gap ${props.isMobileOnly ? 'mobile':''}`}></div>
            { props.isMobileOnly ? (<Col
              className="Title-section"
            >
            </Col>) : (<Col
              className="Title-section"
              colSizes={{ mobile: 4, tablet: 6, desktop: 6 }}
              className="topSpace"
            >
              <Body size="small" primitive="h2">
                {" "}
                *First-year price. Plus taxes, fees & equip. charges. Speeds
                vary. Data allowance and other terms apply. Click BUY for
                details.
              </Body>
            </Col>)}
            <Col
            className="Title-section"
            colSizes={{ mobile: 4, tablet: 5, desktop: 5 }}
            className="topSpace"
            >
            </Col>
          </Row>
        </Grid>
      ) : (
        <Fragment></Fragment>
      )}
    </>
  );
}
